// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"389":"f3ac6b4c","453":"fa8dd2ab","671":"5242fcc4"}[chunkId] + ".chunk.js";
};